<template>
  <v-dialog
    v-model="dialog"
    :persistent="persistent"
    :max-width="maxWidth"
    :scrollable="scrollable"
    :content-class="contentClass"
    :fullscreen="fullscreen"
    :container-class="containerClass"
    v-bind="$attrs"
  >
    <v-card
      :height="cardHeight"
      :max-height="cardMaxHeight"
    >
      <v-card-title class="pa-0 ma-0">
        <span
          v-if="title !== ''"
          class="px-5 py-2"
        >
          {{ title }}
        </span>
        <slot name="title" />
      </v-card-title>
      <slot name="title-append-outer" />
      <v-divider />
      <v-card-text
        ref="scrollContent"
        :class="cardClass"
      >
        <v-container
          :class="containerClass"
          :fluid="fluid"
        >
          <slot />
        </v-container>
      </v-card-text>
      <v-divider v-if="scrollable" />
      <v-card-actions>
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { PropType, ref, watch } from 'vue';
import { TranslateResult } from 'vue-i18n';

const props = defineProps({
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  maxWidth: { type: String, required: false, default: '600' },
  persistent: { type: Boolean, required: false, default: false },
  cardClass: { type: String, required: false, default: null },
  cardHeight: { type: Number, required: false, default: null },
  cardMaxHeight: { type: String, required: false, default: null },
  scrollable: { type: Boolean, required: false, default: false },
  contentClass: { type: String, required: false, default: null },
  containerClass: { type: String, required: false, default: 'pa-md-5 pa-0' },
  fluid: { type: Boolean, required: false, default: false },
  fullscreen: { type: Boolean, required: false, default: false },
});
const emit = defineEmits(['close']);
const dialog = ref(true);
watch(dialog, () => {
  if (dialog.value === false) { emit('close'); }
});

const scrollContent = ref(null as null | HTMLElement);
const scrollToBottom = () => {
  const scrollDiv = scrollContent.value as HTMLElement;
  scrollDiv.scrollTop = scrollDiv.scrollHeight + 60;
};

</script>
